<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    search
                    :settings="false"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'

export default {
    components:{
        BCard
    },
    data(){
        return {
            fields:[
                {name:'İl',key:'Name',thClass:'w-25'},
                {name:'Bölge',key:'RegionName',thClass:'w-25'},
                {name:'Endeks Kategorisi',key:'ProvinceIndexCategoryName',thClass:'w-25'},
                {name:'Katsayı',key:'MultiplierStr',thClass:'w-25'}
            ]
        }
    },
    methods:{
        provider(data){
            return SystemDataApi.ProvinceIndexCategory.IndexesTable(data)
        }
    }
}
</script>